import { Banner } from '../types';
import { createStore, LLStore } from './store';

export type BannerStore = LLStore<Banner[]> & {
  setItem: (banner: Banner) => void;
};

const initialBannerStoreValue: Banner[] = [];

export const bannerStore = createStore(initialBannerStoreValue);

export const bannerStoreActions = {
  addBannerItem(banner: Banner) {
    bannerStore.set([...bannerStore.get(), banner]);
  },
  updateBannerItems(banners: Banner[]) {
    bannerStore.set(banners);
  },
};
